import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderItemCreateSlice = createApi({
    reducerPath: "orderItemCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        orderItemCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/orderitem/create", method: "POST", body: data }),
        }),
    }),
});

export const { useOrderItemCreateMutation } = orderItemCreateSlice;
